export default __webpack_public_path__ + "static/media/project0.5662f567.webp";